import { API_ENDPOINT } from "@/constants/appConstants";
import { PROFILE_STATS_QUERY_KEY } from "@/lib/queryKeys";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { ProfileStatsApiType } from "./types";

export const profileStats = async <T>(): Promise<T | Error> => {
  try {
    const response = await fetch(
      API_ENDPOINT(window.location.host).middleware.profileStats,
      {
        method: "GET",
        credentials: "include",
      },
    );

    const data: T = await response.json();
    return data;
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error(
        `Error occurred while fetching data, ${JSON.stringify(error)}`,
      );
    }
  }
};

export const getProfileStats = (): UseQueryResult<
  ProfileStatsApiType | Error
> => {
  return useQuery({
    queryKey: [PROFILE_STATS_QUERY_KEY],
    queryFn: () => profileStats<ProfileStatsApiType>(),
  });
};
